import { mkObservable } from "./Observable";
export const mk = <T>(t: T) => mkObservable<T>(observer => observer.next(t));
